'use client'

import ViverseAvatar from '@/components/ViverseAvatar'
import ViverseButton from '@/components/ViverseButton'
import * as AlertDialog from '@radix-ui/react-alert-dialog'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

export default function ThankYouDialog({ avatarSrc }: { avatarSrc?: string }) {
  const t = useTranslations()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (window.location.hash === '#tip-success') {
      setIsOpen(true)
    }
  }, [])

  const handleClose = () => {
    setIsOpen(false)
    window.history.replaceState(null, '', window.location.href.split('#')[0])
  }

  return (
    <AlertDialog.Root open={isOpen}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-navigation bg-[#000000B2]" />
        <AlertDialog.Content className="bg-vive-surface-normal/40 xs:min-w-[312px] xs:min-w-none fixed top-1/2 left-1/2 z-navigation flex h-fit w-fit min-w-[calc(100%-48px)] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-6 rounded-[7px] border-none px-6 py-6 pt-16.5 shadow-md backdrop-blur-[50px] outline-none md:max-h-[504px] md:min-h-[216px] md:max-w-[640px] md:min-w-[420px] md:gap-8 md:px-10 md:pb-8">
          <div className="index-99 absolute -top-[50px]">
            <ViverseAvatar size="XL" imageUrl={avatarSrc || ''} />
          </div>
          <div className="flex flex-col items-center gap-2 md:gap-4">
            <AlertDialog.Title className="text-vive-white header2-omni-styles truncate text-center">
              {t('thank-you-dialog.title')}
            </AlertDialog.Title>
            <AlertDialog.Description className="body1-omni-styles text-vive-primary-20">
              {t('thank-you-dialog.description')}
            </AlertDialog.Description>
          </div>
          <div className="flex w-full flex-wrap justify-center gap-4">
            <ViverseButton variant={'default'} size={'medium'} onClick={handleClose}>
              {t('thank-you-dialog.button-label')}
            </ViverseButton>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
